import React, { useEffect, useState } from 'react'

import { useHistory } from 'react-router-dom'

import {
  message, Button, Table, Spin, PageHeader, Divider, Tooltip,
} from 'antd'
import { CommentOutlined } from '@ant-design/icons'

import { format } from 'date-fns'

import { useRecoilState } from 'recoil'

import { fetch } from '../../utils/fetch'

import OrderTypeTag from '../component/OrderType'
import OrderStatus from '../component/OrderStatus'
import { userState } from '../../store'

const { Column } = Table
// eslint-disable-next-line react/prop-types
const ReviewOrder = ({ name }) => {
  const history = useHistory()

  const [orderList, setOrderList] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [user, setUser] = useRecoilState(userState)
  const getDataOrder = () => {
    setIsLoading(true)
    fetch({
      url: '/order/review',
    }).then((res) => {
      if (res.data?.success) {
        setOrderList(res.data?.data)
      } else {
        message.error(res.message)
      }
      setIsLoading(false)
    })
  }

  useEffect(
    () => {
      getDataOrder()
    },
    [],
  )

  const viewDetail = (row) => {
    history.push(`/order/review/${row.orderId}`)
  }

  return (
    <>
      <Spin spinning={isLoading} tip="Loading...">
        <PageHeader
          ghost={false}
          title={name}
        >
          <Divider />
          <Table dataSource={orderList} size="small" scroll={{ x: 1500 }}>
            <Column title="Order Id" dataIndex="orderId" key="orderId" width={150} align="center" sortDirections={['ascend']} sorter={(a, b) => a.orderId - b.orderId} />
            <Column title="Server Id" dataIndex="xmlServerId" key="xmlServerId" width={100} />
            <Column title="Rev." dataIndex="xmlRev" key="xmlRev" width={100} />
            <Column title="Type" dataIndex="orderTypeDetail" key="orderTypeDetail" width={150} render={(text) => (<OrderTypeTag orderType={text?.orderTypeCode} orderTypeDescr={text?.orderTypeDescr} />)} />
            <Column title="Status" dataIndex="status" key="status" width={150} render={(text, row) => { const desc = row.statusDetail; return (<OrderStatus click orderStatus={text} orderId={row.orderId} orderStatusDesc={desc?.statusDescr} />) }} />
            <Column title="Sold to" dataIndex="orderHeader" key="orderHeader" width={150} render={(text) => text?.soldTo || '-'} />
            <Column title="Designer" dataIndex="orderHeader" key="orderHeader" width={150} render={(text) => text?.designer || '-'} />
            <Column title="Sales employee" dataIndex="orderHeader" key="orderHeader" width={150} render={(text) => text?.salesEmp || '-'} />
            <Column title="Created At" dataIndex="createdAt" key="createdAt" width={150} render={(text) => format(new Date(text), 'dd/MM/yyyy HH:mm')} />
            <Column title="Created By" dataIndex="createdBy" key="createdBy" width={150} render={(text) => text || '-'} />
            <Column
              title="Action"
              dataIndex="action"
              key="action"
              fixed="right"
              align="center"
              width={100}
              render={(text, row) => (
                <>
                  <div>
                    {
                      user?.role?.length > 0
                      && ((user.role.includes('ADMIN'))
                        || (user.role.includes('MERCH'))
                        || (user.role.includes('REVIEWER'))
                        || (user.role.includes('ADMIN') && user.role.includes('MERCH'))
                        || (user.role.includes('ADMIN') && user.role.includes('REVIEWER'))
                        || (user.role.includes('MERCH') && user.role.includes('REVIEWER'))
                        || (user.role.includes('ADMIN') && user.role.includes('MERCH') && user.role.includes('REVIEWER')))
                      && (
                        <Tooltip title="Review">
                          <Button
                            shape="circle"
                            icon={<CommentOutlined />}
                            onClick={() => viewDetail(row)}
                          />
                        </Tooltip>
                      )
                    }
                  </div>
                </>
              )}
            />
          </Table>
        </PageHeader>
      </Spin>
    </>

  )
}

export default ReviewOrder
